import React from 'react';
import { string } from 'yup';
import PropTypes from 'prop-types';
import { SelectInput, StyledRadioInput } from '../../../Helpers/Inputs';
import './ConfigurableQuestions.scss';

export function ConfigurableQuestions(props) {
  const { formState, onChange, questionData } = props;

  const handleValueChange = (fieldName, value) => {
    const updatedValue = { ...formState, [fieldName]: value };
    onChange(updatedValue);
  };

  const RenderQuestionField = ({ q, index, value, options, fieldName }) => {
    switch (q.type) {
      case "boolean":
        return (
          <div key={q.question} className="negative-margin">
            <p className="section-title">{q.question}</p>
            <StyledRadioInput
              name={fieldName}
              id={index}
              value={value}
              options={options}
              onChange={(value) => handleValueChange(q.question, value)}
              isBlankIcon
            />
          </div>
        );
  
      case "dropdown":
        return (
          <div key={q.question} className="dropdown-margin">
            <SelectInput
              name={fieldName}
              id={index}
              value={value}
              onChange={(e) => handleValueChange(q.question, e.target.value)}
              label={q.question}
              selectOptions={options}
            />
          </div>
        );
  
      default:
        return null;
    }
  };
  

  return (
    <React.Fragment>
      {questionData?.length > 0 && questionData.map((configQuestion, index) => {
        const { question, answers } = configQuestion;
        const fieldName = `configurableQuestions[${question}]`;
        const options = answers?.map((a) => ({ value: a, label: a })) || [];
        const value = formState?.[question] || '';

        return (
          <div className='configurable-question-container'>

          <RenderQuestionField
            key={question}
            q={configQuestion}
            index={index}
            value={value}
            options={options}
            fieldName={fieldName}
          />
          </div>
        );
      })}
    </React.Fragment>
  );
}

ConfigurableQuestions.propTypes = {
  formState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  questionData: PropTypes.array,
};

export const configurableQuestionsSchemaShape = (activeQuestionList) =>
  activeQuestionList.length > 0 && activeQuestionList.reduce((acc, q) => {
    if (q.type === "boolean" || q.type === "dropdown") {
      acc[q.question] = q.required
        ? string().required("This field is required.")
        : string().notRequired();
    }
    return acc;
  }, {});